import { Component, Input, OnChanges } from '@angular/core';
import { ProductCode } from 'common';
import { BrokerStatus } from '@partner/shared/SharedConstants';
import { LoanData } from '../../../../../../domain/models/loan.model';

@Component({
    selector: 'ifbp-activated-details-loan-section',
    templateUrl: './activated-details-loan-section.component.html',
    styleUrls: ['./activated-details-loan-section.component.scss'],
    standalone: false
})
export class ActivatedDetailsLoanSectionComponent implements OnChanges {
  @Input()
  loan?: LoanData;

  @Input()
  brokerStatus: BrokerStatus;

  repaymentTermValue?: string;
  readonly ProductCode = ProductCode;
  readonly BrokerStatus = BrokerStatus;

  ngOnChanges(): void {
    const repaymentTerm = this.loan?.offer?.repaymentTerm;
    const months = <number>repaymentTerm > 1 ? "months" : "month";
    this.repaymentTermValue = repaymentTerm ? `${repaymentTerm} ${months}` : undefined;
  }
}
